import { useQuery } from '@tanstack/react-query';

import List from '@/components/List/List';
import service from '@/services/index';
import { EXPORT_HISTORY_STATE } from '@/types/exportConst';

import SettingHeader from '../Header';
import ExportHistoryItem from './ExportHistoryItem';

const ExportHistorySettingBody = () => {
  const { data, isLoading } = useQuery({
    queryFn: service.export.fetchExportHistoryList,
    queryKey: ['export-history'],
  });
  return (
    <>
      <SettingHeader title="Export history" />
      <List
        data={data}
        className="p-8 gap-2 h-full"
        render={(d) => (
          <ExportHistoryItem
            key={d.alias}
            {...d}
            inProgress={d.state === EXPORT_HISTORY_STATE.EXPORTING}
          />
        )}
        isLoading={isLoading}
      />
    </>
  );
};

export default ExportHistorySettingBody;
